import { render } from "./DemoProcedure.vue?vue&type=template&id=e937e664&scoped=true"
import script from "./DemoProcedure.vue?vue&type=script&lang=js"
export * from "./DemoProcedure.vue?vue&type=script&lang=js"

import "./DemoProcedure.vue?vue&type=style&index=0&id=e937e664&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e937e664"]])

export default __exports__